<template>
  <div>
    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
        <!--        <el-button v-permisaction="['config:userRemain:export']" icon="el-icon-download" size="mini" @click="exportData(8)">导出</el-button>-->
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column
        prop="gid"
        label="礼包ID"
        align="center"
      />
      <el-table-column
        prop="title"
        label="礼包名称"
        align="center"
      />
      <el-table-column
        prop="price"
        label="价格"
        align="center"
      />
      <el-table-column
        align="center"
        label="统计"
        width="180"
      >
        <el-table-column
          prop="entrance_click"
          label="入口点击"
          align="center"
        />
        <el-table-column
          prop="auto_pop_up"
          label="自动弹出"
          align="center"
        />
        <el-table-column
          prop="buy_count"
          label="购买点击"
          align="center"
        />
        <el-table-column
          prop="buy_succ"
          label="购买成功"
          align="center"
        />
        <el-table-column
          prop="buy_err"
          label="购买失败"
          align="center"
        />
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getLastDates } from '@/utils'
import { getGiftData } from '@/api/statistics/user_remain'

export default {
  name: 'GiftStat',
  data() {
    return {
      tableData: [],
      queryParams: {
        startDate: ''
      }
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(1)
    }
    this.getTables()
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      this.getTables()
    },
    getTables() {
      getGiftData().then(res => {
        this.tableData = res.data
      })
    }
  }
}
</script>

<style scoped>

</style>
